<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" @click="shouye">首页</div>
			<div>/卡号管理</div>
		</div>
		<canvas id="medicalCanvas" width="600" height="400" style="border: 1px solid #ccc;position: fixed;top: -1000px;left: -1000px;"></canvas>
	<div class="w1200" style="padding: 20px;">
		<div class="flex benben-flex-layout flex-wrap align-center">
			<div class="video_0">产品类型：</div>
			<el-select class="video_1" v-model="value1" placeholder="请选择" filterable clearable>
			    <el-option
			      v-for="item in options1"
			      :key="item.aid"
			      :label="item.name"
			      :value="item.aid">
			    </el-option>
			</el-select>
			<div class="video_0 margin_left">品牌：</div>
			<el-select class="video_1" v-model="value2" placeholder="请选择" filterable clearable>
			    <el-option
			      v-for="item in options2"
			      :key="item.aid"
			      :label="item.name"
			      :value="item.aid">
			    </el-option>
			</el-select>
			<div class="video_0 margin_left">激活类型：</div>
			<el-select class="video_1" v-model="value3" placeholder="请选择" filterable clearable>
			    <el-option
			      v-for="item in options3"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<div class="video_0 margin_left">卡号：</div>
			<el-input class="video_1" v-model="value4" placeholder="请输入"></el-input>
			<div class="video_0 margin_left">防伪码：</div>
			<el-input class="video_1" v-model="anti_counterfeiting" placeholder="请输入"></el-input>
			<div class="video_0 margin_left">代理商：</div>
			<el-input class="video_1" v-model="agent" placeholder="请输入"></el-input>
			
			
			<!-- <div class="video_0 margin_left">加工厂名称：</div>
			<el-input class="video_1" v-model="value5" placeholder="请输入"></el-input> -->
			  
			
			<div class="flex justify-content align-content align-center margin_left video_2 pointer" @click="caozuo(1)">
				<img class="video_2_1" src="../../static/image/16.png" alt="" srcset="">
				<div>查询</div>
			</div>
			<div class="flex justify-content align-content align-center margin_left video_3 pointer" @click="caozuo(2)">
				<img class="video_2_1" src="../../static/image/17.png" alt="" srcset="">
				<div>重置</div>
			</div>
		</div>
		<div class="video_4">
			<div class="">
				<el-table :data="tableData" style="width: 86vw" border :header-cell-style="headerCell" :cell-style="{ textAlign: 'center' }">
				    <el-table-column prop="card_number" label="卡号" width="130"></el-table-column>
				    <el-table-column prop="anti_counterfeiting" label="防伪码" width="130"></el-table-column>
					<el-table-column prop="cardlist_unique_identifier" label="唯一身份标识码" width="180"></el-table-column>
					<!-- <el-table-column prop="productname_name" label="产品名称" width="130"></el-table-column> -->
					<el-table-column label="二维码" width="200">
						<template slot-scope="scope">
							<el-image fit="cover" :src="scope.row.cardlist_qrcode" style="width: 100px;height: 100px;" v-if="scope.row.cardlist_qrcode" :preview-src-list="[scope.row.cardlist_qrcode]"></el-image>
						</template>
					</el-table-column>
					
					
				    <el-table-column prop="productname_name" label="产品类型" width="130"></el-table-column>
				    <el-table-column prop="cardinformation_name" label="患者姓名" width="80"></el-table-column>
				    <el-table-column prop="cardinformation_doctor" label="医生姓名" width="80"></el-table-column>
					<el-table-column prop="user_agent" label="代理商" width="80"></el-table-column>
					
					
				    <el-table-column prop="cardinformation_outpatient_name" label="医疗机构" width="130"></el-table-column>
				    <el-table-column prop="cardinformation_dental_position_information" label="牙位" width="130"></el-table-column>
				    <el-table-column prop="cardinformation_number" label="数量" width="80"></el-table-column>
				    <el-table-column prop="brand_name" label="品牌" width="120"></el-table-column>
					<el-table-column prop="series_name" label="系列" width="120"></el-table-column>
				    <el-table-column prop="user_nickname" label="加工厂名称" width="120"></el-table-column>
				    <el-table-column prop="is_activate" label="激活状态" width="100">
						<template slot-scope="scope">
							<div class="relative">
								<div v-if="scope.row.is_activate == 0">未激活</div>
								<div v-if="scope.row.is_activate == 1" class="video_4_1">已激活</div>
							</div>
						</template>
					</el-table-column>
				    <el-table-column prop="create_time" label="创建时间" width="136"></el-table-column>
					
				    <el-table-column prop="date" label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<!-- scope.row -->
							<div class="relative pointer" style="display: flex;align-items: center;justify-content: space-around;">
								<div class="video_4_2" v-if="scope.row.is_activate == 0||scope.row.cardinformation_number>=1" @click="caozuo(4,scope.row)">录入信息</div>
								<div class="video_4_2" v-if="scope.row.is_activate == 1" @click="caozuo(3,scope.row.aid)">查看详情</div>
								<div class="video_4_2" v-if="scope.row.is_activate == 1" @click="generateMedicalImage(scope.row)">打印</div>
								
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="video_4_3">
				<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange" v-if="total > 0"
					:current-page.sync="page" :page-size="page_size" layout="total, sizes,prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<!-- 新增 -->
		<el-drawer title="录入信息" :visible.sync="dialogVisible" direction="rtl">
		    <div class="shuju">
			    <el-form :model="ruleForm" :rules="rules" ref="ruForm" label-width="100px" class="demo-ruleForm">
				    <el-form-item label="卡号：" prop="card_number">
				        <el-input v-model="ruleForm.card_number" class="card_0"></el-input>
				    </el-form-item>
					<el-form-item label="防伪码：" prop="anti_counterfeiting">
					    <el-input v-model="ruleForm.anti_counterfeiting" disabled class="card_0"></el-input>
					</el-form-item>
					<!-- <el-form-item label="唯一身份标识码：" prop="anti_counterfeiting">
					    <el-input v-model="ruleForm.cardlist_unique_identifier" disabled class="card_0"></el-input>
					</el-form-item>
					<el-form-item label="注册证号：" prop="anti_counterfeiting">
					    <el-input v-model="ruleForm.registrationnumber_name" disabled class="card_0"></el-input>
					</el-form-item> -->
					<el-form-item label="患者姓名：" prop="name">
					    <el-input v-model="ruleForm.name" class="card_0"></el-input>
					</el-form-item>
					<el-form-item label="医生姓名：" prop="doctor">
					    <el-input v-model="ruleForm.doctor" class="card_0"></el-input>
					</el-form-item>
					<el-form-item label="门诊名称：" prop="outpatient_name">
					    <el-input v-model="ruleForm.outpatient_name" class="card_0"></el-input>
					</el-form-item>
					<el-form-item label="合作单位：" prop="user_nickname">
					    <el-input v-model="ruleForm.user_nickname" disabled class="card_0"></el-input>
					</el-form-item>
					<el-form-item label="牙位信息：" prop="dental_position_information">
					    <div class="flex wrap">
					    	<template v-for="(item,index) in options8_1">
								<div class="card_9 pointer" :class="ruleForm.dental_position_information.indexOf(item.aid) == -1 ? 'card_1' : 'card_2'" @click="xuanze(item)" >{{item.num}}</div>
							</template>
							
					    </div>
						<div class="flex wrap">
						<template v-for="(item,index) in options8_2">
							<div class="card_9 pointer" :class="ruleForm.dental_position_information.indexOf(item.aid) == -1 ? 'card_1' : 'card_2'" @click="xuanze(item)" >{{item.num}}</div>
						</template>
					    </div>
					</el-form-item>
					<el-form-item label="数量：" prop="number">
					    <el-input v-model="ruleForm.number" type='number' disabled controls-position="none" class="card_0"></el-input>
					</el-form-item>
					<!-- <el-form-item label="品牌：" prop="input9">
					    <el-select class="card_0" v-model="ruleForm.input9" placeholder="请选择" filterable clearable>
					        
							<el-option
							  v-for="item in options2"
							  :key="item.aid"
							  :label="item.name"
							  :value="item.aid">
							</el-option>
					    </el-select>
					</el-form-item>
					<el-form-item label="系列：" prop="input10">
					    <el-select class="card_0" v-model="ruleForm.input10" placeholder="请选择" filterable clearable>
					        <el-option
					          v-for="item in options7"
					          :key="item.value"
					          :label="item.label"
					          :value="item.value">
					        </el-option>
					    </el-select>
					</el-form-item> -->
				</el-form>
				<div class="flex justify-content align-content card_3">
					<div class="pointer card_4" @click="dialogVisible = false">取消</div>
					<div class="pointer card_5" @click="submitForm">提交</div>
				</div>
		    </div>
		</el-drawer>
		<!-- 详情 -->
		<el-drawer title="详细信息" :visible.sync="dialogVible" direction="rtl">
			<div class="flex flex-direction flex-wrap align-center benben-flex-layout">
				<div class="flex card_7  align-center">
					<div class="textsLeft">卡号：</div>
					<div class="card_6_1 flex-sub">{{detal.cardlist_card_number}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">防伪码：</div>
					<div class="card_6_1 flex-sub">{{detal.cardlist_anti_counterfeiting}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">唯一身份标识码：</div>
					<div class="card_6_1 flex-sub">{{detal.cardlist_unique_identifier}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">注册证号：</div>
					<div class="card_6_1 flex-sub">{{detal.registrationnumber_name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">医生姓名：</div>
					<div class="card_6_1 flex-sub">{{detal.doctor}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">患者姓名：</div>
					<div class="card_6_1 flex-sub">{{detal.name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">医疗机构：</div>
					<div class="card_6_1 flex-sub">{{detal.outpatient_name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">加工厂名称：</div>
					<div class="card_6_1 flex-sub">{{detal.user_nickname}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">品牌：</div>
					<div class="card_6_1 flex-sub">{{detal.brand_name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">系列：</div>
					<div class="card_6_1 flex-sub">{{detal.series_name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">产品类型：</div>
					<div class="card_6_1 flex-sub">{{detal.productname_name}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">牙位：</div>
					<div class="card_6_1 flex-sub">{{detal.dental_position_information}}</div>
				</div>
				<div class="flex card_7  align-center">
					<div class="textsLeft">数量：</div>
					<div class="card_6_1 flex-sub">{{detal.number}}</div>
				</div>
				
				<div class="card_8 pointer" @click="dialogVible = false">返回</div>
			</div>
		</el-drawer>
		<!-- 详情 -->
		<el-dialog title="打印信息" :visible.sync="finalImageOnShow" width="40%">
			<div class="flex flex-direction flex-wrap align-center benben-flex-layout">
				<div class="flex card_7  align-center">
					<el-image ref="card_img" :src="finalImageBase64" style="width: 450px;height: 300px;margin: 0 auto;border: 0.5px solid #bbb;"></el-image>
				</div>
				<div style="display: flex;justify-content: space-around;">
					<div class="card_8 pointer" @click="printImage" style="margin-top: 20px;margin-right: 32px;">打印</div>
					<div class="card_8 pointer" @click="downloadImage" style="margin-top: 20px;">下载</div>
				</div>
			</div>
		</el-dialog>
		
	</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				finalImageBase64: '',
				finalImageOnShow:false,
				dialogVible:false,
				ruleForm:{
					card_number:'',
					anti_counterfeiting:'',
					name:'',
					doctor:'',
					outpatient_name:'',
					user_nickname:'',
					dental_position_information:[],
					number:'',
					input9:'',
					input10:'',
				},
				rules: {
				    name: [
				        { required: true, message: '请输入姓名', trigger: 'blur' },
				    ],
					doctor: [
					    { required: true, message: '请输入医生', trigger: 'blur' },
					],
					
					outpatient_name: [
				        { required: true, message: '请输入门诊名称', trigger: 'blur' },
				    ],
					dental_position_information:[
						{required: true, validator: this.validateArrayLength, trigger: 'blur' }
					],
					number: [
					    { required: true, message: '请输入数量', trigger: 'blur' },
						{
						    validator: (rule, value, callback) => {
						    if (/^(?:[1-9]\d*)$/.test(value) == false) {
						        callback(new Error("请输入正整数"));
						    } else {callback();}},trigger: "change",
						},
					],
				},
				dialogVisible:false,
				page:1,
				page_size:10,
				total:100,
				headerCell: {
					'background-color': '#F2F3F5',
					'text-align': 'center',
				},
				options1:[],
				value1: '',
				options2:[],
				value2:'',
				options3:[
					{
					  value: '0',
					  label: '未激活'
					}, {
					  value: '1',
					  label: '已激活'
					}
				],
				value3:'',
				value4:'',
				anti_counterfeiting:'',
				agent:'',
				value5:'',
				value6:'',
				options7:[
					{
					  value: '选项1',
					  label: '黄金糕'
					}, {
					  value: '选项2',
					  label: '双皮奶'
					}, {
					  value: '选项3',
					  label: '蚵仔煎'
					}, {
					  value: '选项4',
					  label: '龙须面'
					}, {
					  value: '选项5',
					  label: '北京烤鸭'
					},
				],
				value7:'',
				tableData:[
					{
						date: '2016-05-04',
						name: '王小虎',
						id: '1'
					}, {
						date: '2016-05-01',
						name: '王小虎',
						id: '2'
					}
				],
				options8_1:[],
				options8_2:[],
				detal:'',
				detal_id:'',
				post_type:false,
				cardlist_available_tooth_position:0
			}
		},
		created() {
			let list1 = []
			let list2 = []
			for (var i = 18; i > 10; i--) {
				list1.push({
					aid:i,
					num:i,
				})
			}
			for (var i = 21; i < 29; i++) {
				list1.push({
					aid:i,
					num:i,
				})
			}
			this.options8_1 = list1
			for (var i = 48; i > 40; i--) {
				list2.push({
					aid:i,
					num:i,
				})
			}
			for (var i = 31; i < 39; i++) {
				list2.push({
					aid:i,
					num:i,
				})
			}
			this.options8_2 = list2
			// this.options8 = list
			this.ordeList()
			this.post691ec294cc358()
			this.post691ae1bbbdba8()
		},
		methods:{
			printImage(){
				this.finalImageOnShow = false; 
				const printContent =this.$refs.card_img;
			    const printWindow = window.open('', ''); 
			    printWindow.document.write('<image ref="card_img" src="'+this.finalImageBase64+'" style="width: 750px;height: 450px;margin: 0 auto;"></image>');
			    printWindow.document.close();
			    setTimeout(() => {
				printWindow.print();
				printWindow.close();
			  }, 500); // 等待页面加载完成后再打印
			},
			
			/**
			     * 核心方法：绘制就诊信息+二维码合成图片
			     */
			    generateMedicalImage(item) {
					let that = this;
					if(!item.cardlist_qrcode){
						this.$message.error('暂无二维码，无法打印');
						return
					}
					
			      // 1. 获取Canvas上下文
			      const canvas = document.getElementById('medicalCanvas');
			      const ctx = canvas.getContext('2d');
			      
			      // 2. 清空画布（避免重复绘制）
			      ctx.clearRect(0, 0, canvas.width, canvas.height);
			
			      // 3. 绘制白色背景（可选，无背景则透明）
			      ctx.fillStyle = '#ffffff';
			      ctx.fillRect(0, 0, canvas.width, canvas.height);
			
			      // 4. 定义需要绘制的文本信息（可替换为业务数据）
			      const clinicName = item.cardinformation_outpatient_name; // 诊所名称
			      const patientName = item.cardinformation_name; // 患者姓名
			      const printDate = new Date().toLocaleString('zh-CN'); // 打印日期（本地化格式）
			      const qrCodeUrl = item.cardlist_qrcode; // 二维码图片地址（替换为实际地址）
			
			      // 5. 绘制文本信息（自定义字体、颜色、位置）
			      // 5.1 绘制诊所名称（大号字体、居中）
			      ctx.font = 'bold 24px Microsoft YaHei';
			      ctx.fillStyle = '#333333'; // 黑色文本
			      ctx.textAlign = 'left'; // 居中对齐
			      // ctx.fillText(patientName, canvas.width / 2, 60); // 位置：画布水平居中，垂直60px
				  ctx.fillText(patientName, 80, 80); // 位置：画布水平居中，垂直60px
			
			      // 5.2 绘制患者姓名（中号字体、左对齐）
			      ctx.font = 'bold 22px Microsoft YaHei';
			      ctx.textAlign = 'left'; // 左对齐
			      ctx.fillText(`${clinicName}`, 80, 140);
				  
				  
			      // 5.3 绘制打印日期（中号字体、左对齐）
				  ctx.font = 'bold 22px Microsoft YaHei';
				  ctx.textAlign = 'left'; // 左对齐
			      ctx.fillText(`${printDate}`, 80, 200);
			
			      // 6. 加载并绘制二维码图片（异步操作，必须等图片加载完成）
			      const qrImage = new Image();
			      // 解决跨域问题（若二维码图片跨域，需服务端配置CORS）
			      qrImage.crossOrigin = 'anonymous';
			      
			      // 6.1 图片加载成功：绘制二维码
			      qrImage.onload = function() {
			        // 二维码尺寸：宽高150px，位置：画布右下角（留出边距）
			        const qrWidth = 150;
			        const qrHeight = 150;
			        const qrX = canvas.width - qrWidth - 100; // 右间距50px
			        const qrY = canvas.height - qrHeight - 200; // 下间距50px
			        
			        // 绘制二维码图片
			        ctx.drawImage(qrImage, qrX, qrY, qrWidth, qrHeight);
			
			        // 7. 生成合成图片的Base64（用于下载/展示）
			        that.finalImageBase64 = canvas.toDataURL('image/png'); // 格式：PNG（也可换image/jpeg）
			        console.log('合成图片Base64：', that.finalImageBase64);
					setTimeout(()=>{
						that.finalImageOnShow = true;
					},500)
			        // alert('图片生成成功！可点击「下载图片」保存');
			      };
			
			      // 6.2 图片加载失败：提示错误
			      qrImage.onerror = function() {
			        alert('二维码图片加载失败，请检查图片地址是否正确！');
			        // 可选：绘制“二维码加载失败”文本占位
			        ctx.font = '16px Microsoft YaHei';
			        ctx.fillStyle = '#ff0000';
			        ctx.fillText('二维码加载失败', canvas.width - 120, canvas.height - 80);
			      };
			
			      // 6.3 触发图片加载（必须写在onload/onerror之后）
			      qrImage.src = qrCodeUrl;
			    },
			
			    /**
			     * 辅助方法：下载合成后的图片
			     */
			     downloadImage() {
			      if (!this.finalImageBase64) {
			        alert('请先点击「生成图片」！');
			        return;
			      }
			
			      // 创建下载链接
			      const link = document.createElement('a');
			      link.href = this.finalImageBase64;
			      // 自定义下载文件名
			      link.download = `就诊信息_${new Date().getTime()}.png`;
			      // 触发点击下载
			      link.click();
			      // 移除临时链接
			      link.remove();
			    },
			
			
			// 产品类型
			post691ec294cc358(){
				this.$api.post(this.$apiUrls.post691ec294cc358, {}).then((res) => {
					if (res.code == 1) {
						this.options1 = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 品牌
			post691ae1bbbdba8(){
				this.$api.post(this.$apiUrls.post691ae1bbbdba8, {}).then((res) => {
					if (res.code == 1) {
						this.options2 = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			shouye(){
				this.$router.push({
					name: 'index',
				});
			},
			// 牙位信息选择
			xuanze(item){
				let index = this.ruleForm.dental_position_information.indexOf(item.aid)
			    if(index == -1){
					console.log(this.ruleForm.dental_position_information.length,this.cardlist_available_tooth_position)
					if(this.cardlist_available_tooth_position!='0'&&this.cardlist_available_tooth_position>this.ruleForm.dental_position_information.length){
						this.ruleForm.dental_position_information.push(item.aid)
					}else{
						this.$message.error('已达最大可选牙位');
					}
				}else{
					this.ruleForm.dental_position_information.splice(index,1)
				}
				this.ruleForm.number = this.ruleForm.dental_position_information.length
				// console.log(this.ruleForm.dental_position_information,123)
			},
			// 牙位信息校验
			validateArrayLength(rule, value, callback){
				// console.log(value,111111111111)
				if (value.length ==0) { // 检查是否为空字符串
				    callback(new Error('请选择牙位信息'));
				}else{
					callback()
				}
			},
			submitForm() {
				let _this = this
				// console.log(1111111111111111)
			    this.$refs.ruForm.validate((valid) => {
					// console.log(valid,11111111111111)
			        if (valid) {
			            _this.post691307e2d1323()
			        } else {
			            // console.log('error submit!!');
			            return false;
			        }
			    });
			},
			// 录入信息
			post691307e2d1323(){
				if(this.post_type){
					return
				}
				// console.log(11111111111111)
				this.post_type = true
				this.$api.post(this.$apiUrls.post691307e2d1323, {
					cardlist_card_number:this.ruleForm.card_number,
					aid:this.ruleForm.aid,
					name:this.ruleForm.name,
					doctor:this.ruleForm.doctor,
					outpatient_name:this.ruleForm.outpatient_name,
					dental_position_information:this.ruleForm.dental_position_information.toString(),
					number:this.ruleForm.number,
				}).then((res) => {
					if (res.code == 1) {
						// this.detal = res.data
						this.$message.success('添加成功！');
						this.post_type = false
						this.dialogVisible = false
						this.page = 1
						this.ordeList()
					} else {
						this.$message.error(res.msg);
						this.post_type = false
						return
					}
				})
				setTimeout(()=>{
					this.post_type = false
				},2000)
			},
			caozuo(type,item){
				if(type == 1){ // 搜索
					this.page = 1
					this.ordeList()
				}else if(type == 2){ // 重置
					this.value1 = ''
					this.value2 = ''
					this.value3 = ''
					this.value4 = ''
					this.anti_counterfeiting = ''
					this.agent = ''
					this.ordeList()
				}else if(type == 3){ // 查看详情
					this.detal_id = item
					this.post691546a0ba6fe()
				}else if(type == 4){ // 录入信息
				    this.ruleForm.aid = item.aid
				    // this.ruleForm.card_number = item.card_number
				    this.ruleForm.anti_counterfeiting = item.anti_counterfeiting
				    this.ruleForm.user_nickname = item.user_nickname
				    this.ruleForm.name = ''
				    this.ruleForm.doctor = ''
				    this.ruleForm.outpatient_name = ''
				    this.ruleForm.number = ''
				    this.ruleForm.dental_position_information = []
					this.dialogVisible = true
					this.cardlist_available_tooth_position = item.cardlist_available_tooth_position
				}
				
			},
			// 卡片详情
			post691546a0ba6fe(){
				this.$api.post(this.$apiUrls.post691546a0ba6fe, {
					cardlist_id:this.detal_id
				}).then((res) => {
					if (res.code == 1) {
						this.detal = res.data
						this.dialogVible = true
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			handleSizeChange1(val) {
				// console.log(`每页 ${val} 条`,this.page);
				this.page_size = val
				this.ordeList()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.page = val
				this.ordeList()
			},
			// 列表
			ordeList() {
				let page = {
					size: this.page_size,
					page: this.page,
					// modetype_id:this.value1,
					brand_id:this.value2,
					is_activate:this.value3,
					card_number:this.value4,
					anti_counterfeiting:this.anti_counterfeiting,
					agent:this.agent,
					// this.value5
					productname_id :this.value1,
					
				}
				this.$api.post(this.$apiUrls.post691305f481f5b, page).then((res) => {
					if (res.code == 1) {
						this.tableData = res.data.data
						this.total = res.data.total
					// console.log(this.total,res.data.total,123)
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	::v-deep {
		.video_1{
			width: 150px;
			height: 32px;
		}
		.video_1 .el-input__inner {
			height: 32px;
		}
		.video_1 .el-icon-circle-close,
		.video_1 .el-icon-arrow-up{
			line-height: 32px !important;
		}
		.video_1 .el-icon-date{
			line-height: 32px !important;
		}
		.video_4_3{
			
			.number{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				margin: 0 8px 0 0;
			}
			.active{
				border: 1px solid #004EA1;
				background: #004EA1;
				color: #FFFFFF;
			}
			.el-icon-arrow-right,
			.el-icon-arrow-left{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				line-height: 32px;
			}
		}
		.el-drawer {
		  width: 800px !important; /* 根据需要调整 */
		}
		.card_0 input::-webkit-outer-spin-button,
		.card_0 input::-webkit-inner-spin-button {
		        -webkit-appearance: none;
		}
		.card_0 input[type="number"]{
			-moz-appearance: textfield;
		}
		 
		.card_0 inpit{
			border: none
		}
	}
	//在style里面添加此段代码即可
	 
	/* CSS */
	

	// .card_0 .el-input__inner::-webkit-outer-spin-button,
	// .card_0 .el-input__inner::-webkit-inner-spin-button {
	//   -webkit-appearance: none !important;
	//   margin: 0 !important; /* 在某些情况下，可能需要额外的样式来确保箭头不显示 */
	// }

	.margin_left{
		margin-left: 16px;
	}
	.video_0{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.video_2{
		width: 72px;
		height: 32px;
		background: #004EA1;
		border-radius: 4px 4px 4px 4px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.video_2_1{
		width: 14px;
		height: 14px;
		margin-right: 8px;
	}
	.video_3{
		width: 72px;
		height: 32px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #004EA1;
		font-weight: 400;
		font-size: 14px;
		color: #004EA1;
	}
	.video_4{
		margin: 20px 0 0 0;
	}
	.video_4_1{
		color: #7EC743;
	}
	.video_4_2{
		color: #004EA1;
	}
	.video_4_3{
		text-align: center;
		margin-top: 20px;
	}
	.card_0{
		width: 400px;
	}
	.card_1{
		width: 30px;
		height: 30px;
		margin: 0 10px 20px 0;
		background: url(../../static/image/20.png) 0 0 no-repeat;
		background-size: 100% 100%;
		text-align: center;
		line-height: 24px;
	}
	.card_2{
		width: 30px;
		height: 30px;
		margin: 0 10px 20px 0;
		background: url(../../static/image/21.png) 0 0 no-repeat;
		background-size: 100% 100%;
		text-align: center;
		line-height: 24px;
		color: #FFFFFF;
	}
	.card_3{
		margin: 70px 0 0 0;
	}
	.card_4{
		width: 148px;
		height: 48px;
		background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 48px;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.card_5{
		width: 148px;
		height: 48px;
		background: #004EA1;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 48px;
		font-weight: 400;
		font-size: 16px;
		color: #fff;
		margin: 0 0 0 20px;
	}
	.card_6{
		width: 90%;
		// height: 40px;
		background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
		padding: 10px 17px;
	}
	.card_6_1{
		margin: 0 0 0 32px;
		text-align: left;
	}
	.card_7{
		width: 90%;
		// height: 40px;
		// background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
		padding: 10px 17px;
	}
	.card_8{
		width: 148px;
		height: 48px;
		background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
		margin-top: 200px;
		text-align: center;
		line-height: 48px;
	}
	.card_9:nth-child(8n) {
		margin-right: 20px;
	}
	
	.textsLeft{
		width:120px;
	}
</style>